import styled from 'styled-components'
import { Text as GrommetText } from 'grommet'

export const Text = styled(GrommetText)`
  line-height: 1.75
`